<template>
  <button
    :disabled="disabled"
    class="button is-primary is-fullwidth next-button"
    @click="nextQuestion()"
  >
    <span v-if="nextButtonText">{{ nextButtonText }}</span>
    <span v-else>Next Question</span>
  </button>
</template>

<script>
import InterviewsService from "../../services/InterviewsService";
import {
  getCurrentQuestion,
  questionHasRoutingLogic,
  clearFileDataFromAnswers
} from "../../store/interview.helpers";
export default {
  name: "next-button",

  props: {
    id: String,
    choice: [String, Array, Number, Boolean, Object],
    hasAnswer: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    disabled() {
      return !this.next;
    },
    next() {
      return this.$store.state.interview.next;
    },
    editMode() {
      return this.$store.state.interview.edit;
    },
    nextButtonText() {
      return this.$store.getters["interview/nextButtonText"];
    }
  },

  methods: {
    nextQuestion() {
      this.$emit("onBeforeNextQuestion");
      if (this.disabled) return;

      const currentQuestion = getCurrentQuestion(this.$store.state.interview);
      const hasRoutingLogic = questionHasRoutingLogic(currentQuestion);

      console.log("currentQuestion=", currentQuestion);

      if (this.$props.hasAnswer) {
        let questionId = this.$props.id;
        let choice = this.$props.choice;
        this.$store.dispatch("interview/recordAnswer", {
          id: questionId,
          choice: choice
        });
        let interview = this.$store.state.interview;
        InterviewsService.update(
          interview.id,
          interview.patientQueue.id,
          clearFileDataFromAnswers(currentQuestion, interview.answers),
          interview.path
        );
      }

      if (this.editMode && hasRoutingLogic == false) {
        this.$router.push({ name: "summary" });
      } else {
        this.$store.dispatch("interview/nextQuestion");
        const p = this.$store.getters["interview/getPage"];
        const q = this.$store.getters["interview/getQuestion"];
        const showSummary = this.$store.getters["interview/showSummary"];
        if (showSummary) {
          this.$router.push({ name: "summary" });
        } else {
          this.$router
            .push({ name: "interview", params: { p, q } })
            .catch(err => {
              console.error(err);
            });
        }
      }
      this.$store.dispatch("interview/setNext", false);
    }
  }
};
</script>
